export default __webpack_public_path__ + "static/media/lockImg.13f65a24.svg";